import { useLang } from 'hooks/lang';

import { invoiceStatusConfig } from 'entities';

import { Column, Row } from 'components/Blocks';
import { MarkInvoiceAsSentButton, DownloadInvoiceExcelButton } from 'pages/Invoice/components';

import { CheckIcon, XIcon } from 'components/Icons';

import { InvoiceTabProps } from './types';

export function SendToAccountant({ invoice, overwrite, changeTab }: InvoiceTabProps): JSX.Element {
  const { t } = useLang();

  return (
    <Column gap="8">
      <h6 className="text-center font-semibold">{t('manage-send-offs')}</h6>

      <Column gap="6" alignItems="center">
        <Row justifyContent="center" gap="2">
          {invoice.downloaded ? <CheckIcon size={16} color="success-light" /> : <XIcon size={16} />}

          <DownloadInvoiceExcelButton
            invoices={[invoice]}
            onSuccess={() => overwrite((invoice) => ({ ...invoice, downloaded: true }))}
          />
        </Row>

        <MarkInvoiceAsSentButton
          disabled={invoice.downloaded}
          invoices={[invoice]}
          onSuccess={() => {
            overwrite((invoice) => ({
              ...invoice,
              status: invoiceStatusConfig.sentToAccountant.code,
            }));

            changeTab('data');
          }}
        />
      </Column>
    </Column>
  );
}
